import { render, staticRenderFns } from "./DeliveryComplete.vue?vue&type=template&id=bb5b6010&scoped=true&lang=pug"
import script from "./DeliveryComplete.vue?vue&type=script&lang=js"
export * from "./DeliveryComplete.vue?vue&type=script&lang=js"
import style0 from "./DeliveryComplete.vue?vue&type=style&index=0&id=bb5b6010&prod&lang=scss&scoped=true"
import style1 from "./DeliveryComplete.vue?vue&type=style&index=1&id=bb5b6010&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb5b6010",
  null
  
)

export default component.exports